export default {
  styleOverrides: {
    paper: {
      borderRadius: 0,
    },
  },
};
